import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import {
	LockOutlined,
	AccountCircleOutlined,
	AttachMoneyOutlined,
	SwapHorizOutlined,
	TrendingUpOutlined,
	LinkOutlined,
} from '@mui/icons-material';

import { Text } from '~/components/Text';
import { SubHeader } from '~/components/SubHeader';
import { StyledLink } from './styles';

function FAQ() {
	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Perguntas Frequentes',
						link: '/client/faq',
					},
				]}
			/>
			<Row className="my-5">
				<Col>
					<Text size="large">Com o que podemos ajudar?</Text>
				</Col>
			</Row>

			<StyledLink to="/">
				<Text size="big" className="d-flex align-items-center">
					<TrendingUpOutlined className="mr-3" />
					Simulador
				</Text>
			</StyledLink>

			<StyledLink to="/client/faq/maquina-virtual">
				<Text size="big" className="d-flex align-items-center">
					<LinkOutlined className="mr-3" />
					Lucree por click
				</Text>
			</StyledLink>

			<StyledLink to="/">
				<Text size="big" className="d-flex align-items-center">
					<AttachMoneyOutlined className="mr-3" />
					Recebimento
				</Text>
			</StyledLink>

			<StyledLink to="/">
				<Text size="big" className="d-flex align-items-center">
					<SwapHorizOutlined className="mr-3" />
					Vendas
				</Text>
			</StyledLink>

			<StyledLink to="/">
				<Text size="big" className="d-flex align-items-center">
					<AccountCircleOutlined className="mr-3" />
					Minha Conta
				</Text>
			</StyledLink>

			<StyledLink to="/">
				<Text size="big" className="d-flex align-items-center">
					<LockOutlined className="mr-3" />
					Segurança
				</Text>
			</StyledLink>
		</Container>
	);
}

export default FAQ;
